// src/components/About.js
import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 20px;
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  color: #5c5c5c;
  font-family: 'Arial', sans-serif;
`;

const About = () => (
  <PageContainer>
    <h1>About Us</h1>
    <p>
      Welcome to the Best Color Palette Generator Tool for Designers! At our core, we believe that color is more than just a visual element—it's a powerful tool that communicates emotions, enhances usability, and strengthens brand identity. Our mission is to empower designers with a robust tool for creating harmonious color palettes effortlessly.
    </p>
    <p>
      Our tool simplifies the process of color selection by leveraging the 6:3:1 ratio method. This method ensures a balanced composition of colors:
      <ul>
        <li><strong>Primary Color:</strong> The dominant hue that defines your brand's personality and message.</li>
        <li><strong>Supporting Colors:</strong> Complementary shades that harmonize with the primary color, adding depth and versatility.</li>
        <li><strong>Accent Color:</strong> A striking hue that highlights key elements and creates visual interest.</li>
      </ul>
    </p>
    <p>
      Whether you're designing websites, mobile apps, or print materials, our advanced color palette generator provides intuitive features to explore, refine, and export your color schemes seamlessly. Achieve visual consistency and professionalism across all your design projects with ease.
    </p>
    <p>
      We're committed to supporting your creative journey. Whether you're a seasoned designer or just starting out, our tool offers the flexibility and precision needed to turn your ideas into reality. Join thousands of designers who trust our platform to elevate their design aesthetics and brand presence.
    </p>
    <p>
      Have feedback or suggestions? We value your input! Visit our Contact page to connect with our team. Let's collaborate and innovate together, one color palette at a time.
    </p>
  </PageContainer>
);

export default About;
